import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { CoinPointsOutline, Flex, StyleProps, Text } from '@bonusly/design-system';
import { useCurrentCompany, useCurrentUser } from '@bonusly/who-am-i';

export const NavMenuBanner: FC<StyleProps> = (props) => {
	const company = useCurrentCompany();
	const user = useCurrentUser();
	const { t } = useTranslation('navigation');

	return (
		<Flex
			bg="points.bgAlpha"
			color="points.fg"
			fontSize="xl"
			fontWeight="medium"
			justifyContent="center"
			alignItems="center"
			p={1.5}
			borderRadius="xl"
			{...props}
		>
			<CoinPointsOutline />

			<Text as="span" fontSize="md" ml={1.5}>
				{t('user_menu.balance_available_to_give', {
					amount: user.giving_balance,
					formatParams: {
						amount: company.budget.format,
					},
				})}
			</Text>
		</Flex>
	);
};
